/**
 * Ordered quantities of an order, keyed by product id, as the form table reads them. Lines whose
 * product left the client catalog are dropped: at the draft status they are not part of the order
 * anymore (COR-1683 removes them server-side).
 *
 * @param {Array<Object>} products - The product orders of the order ({ productId, quantity })
 * @param {Array<Object>} catalog - The active catalog lines of the client
 *
 * @returns {Object} The quantities keyed by product id
 */
export const buildQuantitiesByProductId = (products, catalog) => {
  const catalogProductIds = new Set(catalog.map(({ productId }) => productId));

  return (products ?? []).reduce((quantities, { productId, quantity }) => {
    if (!catalogProductIds.has(productId)) {
      return quantities;
    }

    quantities[productId] = quantity;

    return quantities;
  }, {});
};
